import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { withTranslation } from 'react-i18next';
import md5 from 'md5';

import { wsFindByCatalogNumber } from '../../../actions/search-actions';
import { addItem } from '../../../actions/basket-actions';
import { ga4TrackSearch, ga4TrackBasketItems } from '../../../core/utils';

const WAIT_INTERVAL = 500;
const ENTER_KEY = 13;
const MIN_LENGTH_FOR_SEARCH = 5;

class FindByCatalogNumber extends React.Component {

    state = {
        catalogNumber: '',
        timer: null
    }

    highlight = ( catalogNumber ) => {

        setTimeout( () => {
            document.querySelectorAll( `[data-md5='${md5( catalogNumber )}']` )[0].classList.add( 'hightlight' );
        }, 500 );

        setTimeout( () => {
            document.querySelectorAll( `[data-md5='${md5( catalogNumber )}']` )[0].classList.remove( 'hightlight' );
        }, 750 );

        setTimeout( () => {
            document.querySelectorAll( `[data-md5='${md5( catalogNumber )}']` )[0].classList.add( 'hightlight' );
        }, 1000 );

        setTimeout( () => {
            document.querySelectorAll( `[data-md5='${md5( catalogNumber )}']` )[0].classList.remove( 'hightlight' );
        }, 1250 );

    }

    triggerChange = async ( ) => {
        const { props: { addItem, basket: { items } }, state: { catalogNumber }, highlight } = this;

        //something is in search input
        if ( !catalogNumber || catalogNumber.length < MIN_LENGTH_FOR_SEARCH ) {
            return;
        }
        try {
            const response = await wsFindByCatalogNumber( catalogNumber );

            //the ONE item was found by catalog number
            if ( !response.data ) {
                ga4TrackSearch( catalogNumber, 'not-found', 'BBB basket catalogNumber search' );
                return;
            }
            ga4TrackSearch( catalogNumber, 'found', 'BBB basket catalogNumber search' );            

            //check if the item is already in basket
            const inBasketArr = items.filter( i => i.catalogNumber === response.data.catalogNumber );
            
            if ( inBasketArr.length === 0 ) {
                const nextQty = 1;        
                ga4TrackBasketItems( response.data, 0, nextQty );
                addItem( response.data.catalogNumber, nextQty );
            }

            highlight( response.data.catalogNumber );

            this.setState( { catalogNumber: '' } );
        } catch ( error ) {
            console.error( error );
        }
    }

    handleChange = ( e ) => {
        const { state: { timer }, triggerChange } = this;
        clearTimeout( timer );

        this.setState( {
            catalogNumber: e.currentTarget.value.trimLeft(),
            timer: setTimeout( triggerChange, WAIT_INTERVAL )
        } );

    }

    handleKeyDown = ( e ) => {
        const { triggerChange } = this;

        if ( e.keyCode === ENTER_KEY ) {
            triggerChange();
        }

    }

    render() {
        const { state: { catalogNumber }, handleChange, handleKeyDown } = this;


        return (
                <React.Fragment>
                    <small className="basket-quick-search">
                        <span className="hidden-xs">{ this.props.t( 'basket.wizard.findByCatalogNumber.label' ) }</span> 
                        <input className="basket-search-item" 
                               type="text"
                               value={catalogNumber} 
                               onChange={handleChange} 
                               autoComplete="off" 
                               onKeyDown={handleKeyDown} 
                               placeholder={ this.props.t( 'basket.wizard.findByCatalogNumber.placeholder' ) }/>
                    </small>
                </React.Fragment>
                );
    }

}

const mapStateToProps = (state) => ({
    basket: state.basket
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    addItem
}, dispatch );

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()( FindByCatalogNumber ));